module.exports = __webpack_public_path__ + "img/com.aeg.wellbeing.b7b7c828.webp";